/* --------------------- SHARED REDUCER HELPERS --------------------- */
export const handleRequest = (state: any, key: string) => ({
  ...state,
  [key]: {
    ...state[key],
    loading: true,
    error: null,
    message: null,
  },
});

export const handleSuccess = (state: any, key: string, response: any) => ({
  ...state,
  [key]: {
    ...state[key],
    loading: false,
    response,
    message: response?.message || null,
    error: null,
  },
});

export const handleFailure = (state: any, key: string, error: any) => ({
  ...state,
  [key]: {
    ...state[key],
    loading: false,
    error,
    message: error?.message || 'An error occurred',
  },
});

export const handleClear = (state: any, key: string) => ({
  ...state,
  [key]: {
    loading: false,
    response: null,
    error: null,
    message: null,
  },
});
